/* =======================================================================
   Diploma Framing Upsell
   -----------------------------------------------------------------------
   When a customer adds the Custom Photo Framing product to their cart,
   pop up a modal offering Professional Diploma Framing as a companion
   piece. Two choices:

     • "Yes, show me diploma framing"   → navigate to the diploma product
                                           page (customer configures size
                                           / school on that product's own
                                           form).
     • "No thanks"                       → dismiss.

   The popup does NOT touch the cart. The photo framing the customer
   just added stays put regardless of which button they click, so this
   upsell is strictly additive — it never interferes with the purchase
   they came to make.

   Every qualifying add-to-cart fires the popup (no session-storage
   suppression). Business preference — customers who dismiss and later
   add the trigger product again should see the offer again. The only
   skip is when the upsold product is already in the cart.

   Runs parallel to framing-upgrade.js but scoped to window.DiplomaUpsell
   with its own data-diploma-upsell-* attributes so the two popups never
   collide.
   ======================================================================= */

(function () {
  'use strict';

  if (!window.DiplomaUpsell || !window.DiplomaUpsell.config) return;
  if (!window.jQuery) return;   // framing-upgrade.js depends on jQuery too.
  var $ = window.jQuery;

  var CONFIG = window.DiplomaUpsell.config;
  var TRIGGER_HANDLES = CONFIG.triggerHandles || [];
  var TRIGGER_TITLE_RE = CONFIG.triggerTitleRegex
    ? new RegExp(CONFIG.triggerTitleRegex, 'i')
    : null;
  var DIPLOMA_URL = CONFIG.diplomaUrl || '/products/diploma-framing';
  // Handle of the product we're upselling — used to skip the popup
  // if it's already in the cart (avoids offering something the
  // customer already has).
  var UPSELL_HANDLE = CONFIG.upsellHandle || 'diploma-framing';

  // ---------------------------------------------------------------------
  // 1. Eligibility — is the just-added line item the Custom Photo
  //    Framing product? /cart/add.js returns `handle` and `product_title`;
  //    we match handle first, fall back to a title regex.
  // ---------------------------------------------------------------------
  function isTriggerProduct(lineItem) {
    if (!lineItem) return false;
    if (lineItem.handle && TRIGGER_HANDLES.indexOf(lineItem.handle) !== -1) return true;
    var title = lineItem.product_title || lineItem.title || '';
    if (TRIGGER_TITLE_RE && TRIGGER_TITLE_RE.test(title)) return true;
    return false;
  }

  function cartContainsUpsellProduct(cart) {
    if (!cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === UPSELL_HANDLE) return true;
    }
    return false;
  }

  // ---------------------------------------------------------------------
  // 3. Modal DOM plumbing.
  // ---------------------------------------------------------------------
  var $modal;
  var $confirmLink;
  var $headingEl;
  var $bodyEl;
  var $bundleBadge;

  function ensureModal() {
    if ($modal && $modal.length) return $modal;
    $modal = $('#DiplomaUpsellModal');
    if (!$modal.length) return null;

    $confirmLink = $modal.find('[data-diploma-upsell-confirm]');
    $headingEl   = $modal.find('[data-diploma-upsell-heading]');
    $bodyEl      = $modal.find('[data-diploma-upsell-body]');
    $bundleBadge = $modal.find('[data-diploma-upsell-bundle-badge]');

    // Make sure the confirm link points at the configured URL. The
    // snippet hard-codes a sensible default, but config is the source
    // of truth (supports preview URLs / future locale prefixes).
    $confirmLink.attr('href', DIPLOMA_URL);

    $modal.on('click', '[data-diploma-upsell-close]', closeModal);
    // Clicking "Yes" should just navigate — we let the anchor do its
    // native thing. We only close the modal on the off chance the
    // navigation is delayed (e.g. slow network) so the UI doesn't look
    // stuck.
    $confirmLink.on('click', function () { closeModal(); });

    $(document).on('keydown.diplomaUpsell', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    return $modal;
  }

  function openModal() {
    var $m = ensureModal();
    if (!$m) return;

    // Populate copy from config (localizable later via Liquid).
    if (CONFIG.strings && CONFIG.strings.modalHeading) $headingEl.text(CONFIG.strings.modalHeading);
    if (CONFIG.strings && CONFIG.strings.modalBody)    $bodyEl.text(CONFIG.strings.modalBody);
    if (CONFIG.strings && CONFIG.strings.bundleBadge && $bundleBadge && $bundleBadge.length) {
      $bundleBadge.text(CONFIG.strings.bundleBadge);
    }
    if (CONFIG.strings && CONFIG.strings.confirm)      $confirmLink.text(CONFIG.strings.confirm);
    if (CONFIG.strings && CONFIG.strings.decline) {
      $modal.find('.frame-modal__decline').text(CONFIG.strings.decline);
    }

    $m.attr('aria-hidden', 'false').addClass('frame-modal--active');
    $('body').addClass('frame-modal-open');
  }

  function closeModal() {
    if (!$modal || !$modal.length) return;
    $modal.attr('aria-hidden', 'true').removeClass('frame-modal--active');
    $('body').removeClass('frame-modal-open');
  }

  // ---------------------------------------------------------------------
  // 4. Hook into add-to-cart. We listen to jQuery's global ajaxComplete
  //    for POSTs to /cart/add.js — same pattern as framing-upgrade.js.
  //
  //    Critical: we do NOT block or modify the cart response in any way.
  //    The add-to-cart has already succeeded by the time ajaxComplete
  //    fires; we just react to it by showing the popup.
  // ---------------------------------------------------------------------
  $(document).ajaxComplete(function (event, xhr, settings) {
    if (!settings || !settings.url) return;
    if (!/\/cart\/add(\.js)?$/.test(settings.url)) return;

    var lineItem = null;
    try { lineItem = JSON.parse(xhr.responseText); }
    catch (e) { return; }
    if (!lineItem || !lineItem.id) return;

    if (!isTriggerProduct(lineItem)) return;

    // Skip if diploma framing is already in the cart. Pulling the
    // full cart is the reliable way to check — the /cart/add.js
    // response only tells us about the line that was just added.
    $.ajax({ url: '/cart.js', dataType: 'json' }).done(function (cart) {
      if (cartContainsUpsellProduct(cart)) return;
      openModal();
    });
  });
})();
